'use strict';

export class ProfileUserRating {
	constructor(component_key) {
		this.id = component_key;
		this.data = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		this.initEventListeners();
	}

	initEventListeners() {
		// Comment Button logic from main.js
		this.$root.on('click', '.js-ur_comment_btn', (e) => {
			const $btn = jQuery(e.currentTarget);
			const reviewID = $btn.data('review_id');
			const $textarea = this.$root.find('.js-comment_' + reviewID);

			if ($textarea.val()) {
				jQuery.post('/api/ajax/user_rating', {
					action: 'comment',
					reviewID: reviewID,
					ctrl_str: $btn.data('ctrl_str'),
					text: $textarea.val(),
					username: $btn.data('nickname'),
					countryID: yalwa.v.countryID
				}, (html) => {
					const $comment = this.$root.find('.js-rating_list_item[data-reviewid="' + reviewID + '"] .js-lpp_rating_comment');
					$comment.parent().animate({ opacity: 0 }, 200, () => {
						$comment.html(html);
						$comment.parent().animate({ opacity: 1 }, 200);
					});
				});
			} else {
				yalwa.basics.toast({ message: $textarea.data('error_message'), type: 'error' });
			}
		});

		// Delete comment
		this.$root.on('click', '.js-delete_comment', (e) => {
			const $btn = jQuery(e.currentTarget);
			const reviewID = $btn.data('review_id');
			jQuery.post('/api/ajax/user_rating', {
				action: 'delete-comment',
				reviewID: reviewID,
				ctrl_str: $btn.data('ctrl_str'),
				username: $btn.data('nickname'),
				countryID: yalwa.v.countryID
			}, () => {
				yalwa.basics.reload();
			});
		});

		// Toggle comment form
		this.$root.on('click', '.js-add_comment, .js-cancel_comment', (e) => {
			const $item = jQuery(e.currentTarget).closest('.js-rating_list_item');
			$item.find('.js-comment_form').toggleClass('hidden');
		});
	}
}

Object.keys(yalwa.v.components).forEach(key => {
	if (key.startsWith('profileuserrating_')) {
		new ProfileUserRating(key).init();
	}
});